import type * as api from '@gitbook/api-client';
import { allTranslationLanguages, translationLanguageDescriptors } from '@gitbook/app-translations';
import { Emoji } from '@gitbook/spine-react';

import { GlossaryLanguagesButton } from './GlossaryLanguagesButton';
import type { GlossaryStateActions } from './state';

export function GlossaryTableHeader(props: {
    displayedLanguages: api.TranslationLanguage[];
    actions: GlossaryStateActions;
}) {
    const { displayedLanguages, actions } = props;

    const areAllLanguagesDisplayed = displayedLanguages.length === allTranslationLanguages.length;

    return (
        <div className="sticky top-0 z-10 table-header-group bg-base shadow-subtle">
            <div className="table-row">
                {displayedLanguages.map((language) => (
                    <div key={language} className="table-cell w-48 border">
                        <div className="flex items-center gap-2 px-4 py-2">
                            <Emoji
                                code={translationLanguageDescriptors[language].emoji}
                                size={16}
                            />
                            <span className="text-secondary text-ui-action">
                                {translationLanguageDescriptors[language].label}
                            </span>
                        </div>
                    </div>
                ))}
                {areAllLanguagesDisplayed ? null : (
                    <div className="table-cell border">
                        <div className="p-0.5">
                            <GlossaryLanguagesButton
                                displayedLanguages={displayedLanguages}
                                actions={actions}
                                mode="add"
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
